











































































































































































































































































































































































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';

/* import all the components needed in the page */
import { SwForm, SwFormRow, SwFormColumn } from '@libs-uuif/shared/sw-form';
import { SwSteps } from '@libs-uuif/shared/sw-steps';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import { SwModal, SwModalBody } from '@libs-uuif/shared/sw-modal';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import  { MswApiService } from '@/shared/msw-api-service';
import { envCongif } from '@/shared/env.config';
import { InfoState } from '@/core';

const cssPrefix = 'sw-ftr-form';
const cssPrefix2 = 'operator_wrapper';
const COMPLETE = 'complete';
const ACTIVE = 'active';
const DEFAULT = 'default';
const FINISH = 'Submit';
const NEXT = 'Next';
// Below is the RegEx to validate Server Host Name
const hostNameRegex = new RegExp('(?=^.{4,253}$)(^((?!-)[a-zA-Z0-9-]{0,62}[a-zA-Z0-9]\.)+[a-zA-Z]{2,63}$)');

@Component({
  components: {
    SwButton,
    SwForm,
    SwFormRow,
    SwFormColumn,
    SwModal,
    SwModalBody,
    SwSteps,
    SwTextfield,
    SwSelect,
    SwCheckbox,
    SwIcon,
  },
  directives: {
    tooltip,
  },
})
export default class DattoConfigurationWizard extends SwExtendedVue {
  // below prop is used to show/hide the modal
  @Prop({ default: false }) display: boolean;

  cssPrefix = cssPrefix;
  cssPrefix2 = cssPrefix2;
  maskedInputType: string = 'password';
  showInputError: boolean = false;

  environment: string = envCongif.env !== 'PROD' ? envCongif.env : '';
  // below is the data for steps in wizard
  steps = [
    {
      label: '1',
      title: this.$t('psaIntegration.server')
      .toString(),
      state: 'active',
    },
    {
      label: '2',
      title: this.$t('psaIntegration.operators')
      .toString(),
      state: 'default',
    },
    {
      label: '3',
      title: this.$t('psaIntegration.review')
      .toString(),
      state: 'default',
    },
  ];
  count: number = this.steps.length;
  activeIndex: number = 0;
  btnName: string = 'Next';
  modalTemp: boolean = false;
  statusMessage: string = '';
  showMessage: boolean = false;
  messageColor: boolean = false;
  wizardBodyTitle: string[] = [
    this.$t('psaIntegration.dattoAutotask.accountDetails')
    .toString(),
    '',
    this.$t('psaIntegration.confirmSettings')
    .toString(),
  ];
  empSearched: string = '';
  oprSearched: string = '';
  selectedEmployees: any = [];
  employees: any = [];
  tempEmployees: any = [];
  filteredSearchEmpList = this.employees;
  selectedEmpFlag: boolean | 'semi' = false;
  selectedOperators: any = [];
  operators: any = [];
  tempOperators: any = [];
  selectedOprFlag: boolean | 'semi' = false;
  fieldType: string = 'password';

  changeFieldType() {
    if (this.fieldType === 'password') {
      this.fieldType = 'text';
    } else {
      this.fieldType = 'password';
    }
  }

  get userRolesFromLocal() {
    return JSON.parse((localStorage as any).getItem('currentUser'));
  }
  get operator() {
    return this.operators;
  }

  // get isSyncChecked() {
  //   return this.$store.getters['PSAIntegrationStoreModule/getIsSyncChecked'];
  // }

  get integrationDetailsFromStore() {
    console.warn('Server detsils from store(Config wizard) ', { ...this.$store.getters['DattoAutotaskStoreModule/getAutotaskIntegrationDetails'] });
    return { ...this.$store.getters['DattoAutotaskStoreModule/getAutotaskIntegrationDetails'] };
  }

  get tempIntegrationDetails() {
    return this.$store.getters['DattoAutotaskStoreModule/getAutotaskIntegrationDetailsTemp'];
  }

  get displayModal() {
    this.modalTemp = this.display;
    // console.warn(this.userRolesFromLocal);
    return this.modalTemp;
  }

  get previousDisabled() {
    return this.activeIndex !== 0;
  }

  get employeeList() {
    return this.$store.getters['DattoAutotaskStoreModule/getEmployees'];
  }

  set displayModal(newValue) {
    this.modalTemp = newValue;
  }

  get isStep1Validated() {
    console.warn(this.integrationDetailsFromStore.apiUserName !== '' &&
      this.integrationDetailsFromStore.apiPassword !== '');
    if (
      this.integrationDetailsFromStore.apiUserName !== '' &&
      this.integrationDetailsFromStore.apiPassword !== ''
    ) {
      return false;
    }
    return true;
  }

  // syncCheckboxStateChanged(state: boolean) {
  //   this.$store.commit('PSAIntegrationStoreModule/syncCheckChanged', state);
  // }

  validateServerUrl() {
    if (!this.integrationDetailsFromStore.apiUserName.match(hostNameRegex) && this.integrationDetailsFromStore.apiUserName !== '') {
      this.renderErrorMessage(
        'Invalid Server Host Name.',
      );
      return false;
    }
    if (
        this.statusMessage ===
        'Invalid Server Host Name.'
      ) {
      this.hideErrorMessage();
    }
    return true;
  }

  testConnection() {
    this.$store.commit('stopLoading');
    this.$store
      .dispatch('DattoAutotaskStoreModule/checkIntegrationConfig')
      .then(() => {
        this.renderErrorMessage(
          this.$t('psaIntegration.dattoAutotask.msg6')
          .toString(),
          true,
        );
      })
      .catch((error) => {
        if (error.response) {
          this.renderErrorMessage(error.response.data.message);
        } else {
          this.renderErrorMessage(this.$t('psaIntegration.connectwiseManage.genErrMsg1')
          .toString());
        }
        console.error(error);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  validateServerDetails() {
    this.$store.commit('startLoading');
    this.$store
      .dispatch('DattoAutotaskStoreModule/checkIntegrationConfig')
      .then(() => {
        this.incrementStepCount();
        // this.$store.commit('PSAIntegrationStoreModule/stopLoading');
      })
      .catch((error) => {
        if (error.response) {
          this.renderErrorMessage(error.response.data.message);
        } else {
          this.renderErrorMessage(this.$t('psaIntegration.connectwiseManage.genErrMsg1')
          .toString());
        }
        console.error(error);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  storeConfigurations() {
    this.$store
      .dispatch('DattoAutotaskStoreModule/saveAutotaskIntegrationDetails')
      .then((resp:any) => {
        this.$store.commit('DattoAutotaskStoreModule/updateSubmitted', true);
        // this.$emit('modalClosed');
        console.warn('inside store config');
        if (resp.message === 'Success') {
          this.closeModal();
          this.showToastMessage(
            this.$t('psaIntegration.dattoAutotask.msg7')
            .toString(),
            'success',
          );
        }
        this.$store.commit('DattoAutotaskStoreModule/mutate', { property: 'modalClosed', with: true });
        this.showWizardInitialState();
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 500) {
            this.$store.commit('DattoAutotaskStoreModule/updateSubmitted', true);
            this.$emit('modalClosed');
            this.showWizardInitialState();
            this.showToastMessage(
              this.$t('psaIntegration.dattoAutotask.msg8')
              .toString(),
              'major',
            );
          } else {
            this.showToastMessage(
              error.response.data.message || this.$t('psaIntegration.dattoAutotask.msg7')
              .toString(),
              'major',
            );
          }
        } else {
          this.renderErrorMessage(this.$t('psaIntegration.connectwiseManage.genErrMsg1')
          .toString());
        }
        console.error(error);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  getLabelById(arr: any, value: any) {
    if (arr && value) {
      const element = arr.filter((obj: any) => obj.id === value)[0];
      if (element) {
        return element.label;
      }
      return '';
    }
  }

  isConfigurationUpdated() {
    // console.warn(JSON.stringify(this.tempIntegrationDetails));
    // console.warn(JSON.stringify(this.integrationDetailsFromStore));
    if (
      JSON.stringify(this.tempIntegrationDetails) !==
        JSON.stringify(this.integrationDetailsFromStore)
    ) {
      return true;
    }
    return false;
  }

  closeModal() {
    this.$emit('modalClosed');
    this.hideErrorMessage();
  }

  updateIntegrationDetails(key: any, event: any) {
    console.warn(event);
    this.$store.commit('DattoAutotaskStoreModule/updateAutotaskIntegrationDetails', { key, value: event });
  }

  updateEmployeeList(emp:any) {
    this.$store.commit('DattoAutotaskStoreModule/updateEmployees', emp);
  }

  renderErrorMessage(message: string, color: boolean = false) {
    this.messageColor = color;
    this.showMessage = true;
    this.statusMessage = message;
  }

  hideErrorMessage() {
    this.showMessage = false;
  }

  // below methods are used to navigate between steps in wizard
  incrementStepCount() {
    this.steps[this.activeIndex].state = COMPLETE;
    this.activeIndex += 1;
    this.steps[this.activeIndex].state = ACTIVE;
    if (this.activeIndex === this.count - 1) {
      this.btnName = FINISH;
    }
  }

  onNext() {
    // console.warn(this.btnName);
    if (this.btnName === FINISH) {
      // console.warn(this.isConfigurationUpdated());
      if (this.isConfigurationUpdated() || !this.isConfigurationUpdated()) {
        console.warn('calling save autotask');
        this.storeConfigurations();
      } else {
        this.$store.commit('DattoAutotaskStoreModule/updateSubmitted', true);
        this.$emit('modalClosed');
      }
    } else if (this.activeIndex < this.count - 1) {
      this.hideErrorMessage();
      if (this.activeIndex === 0) {
        if (this.validateServerUrl()) {
          this.validateServerDetails();
        }
        // this.incrementStepCount();
      } else if (this.activeIndex === 1) {
        this.incrementStepCount();
      }
    }
  }

  onPrev() {
    this.hideErrorMessage();
    if (this.activeIndex > 0 && this.activeIndex < this.count) {
      this.steps[this.activeIndex].state = DEFAULT;
      this.activeIndex -= 1;
      this.steps[this.activeIndex].state = ACTIVE;
      this.btnName = NEXT;
    }
  }
  showWizardInitialState() {
    this.btnName = NEXT;
    // this.steps[3].state = DEFAULT;
    this.steps[2].state = DEFAULT;
    this.steps[1].state = DEFAULT;
    this.steps[0].state = ACTIVE;
    this.activeIndex = 0;
  }

  usersList() {
    // const userGroupId = this.$store.getters['AccessManagementStoreModule/getSelectedUserGroupObject'].partyGroupId || '';
    return MswApiService.userListSection.getUserListWithRecAdded('bRecAdded=NO')
      .then((resp:any) => {
        if (resp.operationStatus === 'OK' && resp.content) {
          if (resp.content.userList && resp.content.userList.length !== 0) {
            let userList = resp.content.userList;
            // console.warn(resp.content);
            userList = userList.filter((us:any) => us.employee === 'YES');
            let allEmployees = userList.map((usr:any) => { return { userName: usr.emailAddress, fullName: usr.fullName }; });
            // console.warn(allEmployees);
            // console.warn(this.integrationDetailsFromStore);
            if (typeof this.integrationDetailsFromStore.userList === 'string') {
              const tempList = this.convertStringToArrayOfObjects(this.integrationDetailsFromStore.userList);
              console.warn(tempList);
              this.integrationDetailsFromStore.userList = tempList;
            }
            const usersAsOperators = JSON.parse(JSON.stringify(this.integrationDetailsFromStore.userList));
            // console.warn(typeof usersAsOperators);
            // console.warn(allEmployees.filter((emp:any) => usersAsOperators.some((em:any) => emp.userName === em.userName)));
            allEmployees = allEmployees.filter((emp:any) => !usersAsOperators?.some((em:any) => emp.userName === em.userName));
            this.updateEmployeeList(allEmployees);
            this.employees = JSON.parse(JSON.stringify(this.employeeList));
            this.operators = usersAsOperators || [];
            // console.warn(this.employees);
            this.tempEmployees = this.employees;
            this.tempOperators = this.operators;
          }
          if (resp.msgCode === 'MSWAPP:EMPTYUSERLIST') {
            console.warn('No users found');
            // this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
            // if (this.steps[2].state === 'active') {
            //   this.renderErrorMessage(resp.msgDesc);
            // }
          }
        } else {
          this.$store.commit('enqueueMessage', {
            infoType: 'failed',
            infoMsg:  resp.msgDesc || this.$t('systemMessages.wrong')
            .toString(),
          },
          );
        }
      });
  }

  onEmployeeSelect() {
    // console.warn(value);
    if (this.selectedEmployees.length === this.employees.length) {
      this.selectedEmpFlag = true;
    } else if (this.selectedEmployees.length > 0) {
      this.selectedEmpFlag = 'semi';
    } else {
      this.selectedEmpFlag = false;
    }
  }

  onAllEmployeeSelect(value:any) {
    if (value === true) {
      this.selectedEmpFlag = true;
      this.employees.map((emp:any) => this.selectedEmployees.push(emp.userName));
    } else {
      this.selectedEmpFlag = false;
      this.selectedEmployees = [];
    }
    // console.warn(value);
  }

  onOperatorSelect() {
    // console.warn(value);
    if (this.selectedOperators.length === this.operators.length) {
      this.selectedOprFlag = true;
    } else if (this.selectedOperators.length > 0) {
      this.selectedOprFlag = 'semi';
    } else {
      this.selectedOprFlag = false;
    }
  }

  onAllOperatorSelect(value:any) {
    if (value === true) {
      this.selectedOprFlag = true;
      this.operators.map((emp:any) => this.selectedOperators.push(emp.userName));
    } else {
      this.selectedOprFlag = false;
      this.selectedOperators = [];
    }
    // console.warn(value);
  }

  // @Watch('empSearched')

  // searchEmployee() {
  //   this.filteredSearchEmpList = this.employees.filter((each:any) => each.label.toLowerCase()
  //   .indexOf(this.empSearched.toLowerCase()) > -1);
  // }
  addUsersToOperators() {
    if (this.selectedEmployees.length > 0) {
      let emplList = this.employees;
      let operatorList = this.operators;
      emplList.map((emp:any) =>
        this.selectedEmployees.map((se:any) => {
          if (se === emp.userName) operatorList.push(emp);
        }));
      if (this.selectedEmployees.length === emplList.length) {
        emplList = [];
      } else {
        // emplList.splice(emplList.findIndex((emp:any) => this.selectedEmployees.some((se:any) => emp.userName === se)), 1);
        emplList = emplList.filter((emp:any) => !this.selectedEmployees.some((semp:any) => semp === emp.userName));
        // console.warn(this.selectedEmployees);
        // console.warn(emplList);
      }
      this.selectedEmployees = [];
      this.selectedEmpFlag = false;
      const dataObject:any = {};
      operatorList.forEach((datum:any) => {
        if (!Object.hasOwnProperty(datum.userName)) {
          dataObject[datum.userName] = datum;
        }
      });
      operatorList = Object.values(dataObject);
      console.warn(operatorList);
      this.updateEmployeeList(emplList);
      this.updateIntegrationDetails('userList', operatorList);
      this.employees = JSON.parse(JSON.stringify(this.employeeList));
      this.operators = JSON.parse(JSON.stringify(this.integrationDetailsFromStore.userList));
      this.tempEmployees = this.employees;
      this.tempOperators = this.operators;
      // console.warn(this.integrationDetailsFromStore);
      // this.operators = this.integrationDetailsFromStore.userList;
      // console.warn(this.operators);
    } else {
      this.$store.commit('enqueueMessage', {
        infoType: 'failed',
        infoMsg: this.$t('psaIntegration.noUsersSelected')
        .toString(),
      },
      );
      // this.renderErrorMessage('No users selected.');
    }
  }

  removeUsersFromOperators() {
    if (this.selectedOperators.length > 0) {
      let emplList = this.employees;
      let operatorList = this.operators;
      operatorList.map((opr:any) =>
        this.selectedOperators.map((so:any) => {
          if (so === opr.userName) { emplList.push(opr); }
        }));
      if (this.selectedOperators.length === operatorList.length) {
        operatorList = [];
      } else {
        // operatorList.splice(this.operators.findIndex((opr:any) => this.selectedOperators.some((so:any) => opr.userName === so)), 1);
        operatorList = operatorList.filter((opr:any) => !this.selectedOperators.some((sopr:any) => sopr === opr.userName));
        // console.warn(operatorList);
        // console.warn(this.selectedOperators);
      }
      this.selectedOperators = [];
      this.selectedOprFlag = false;
      const dataObject:any = {};
      emplList.forEach((datum:any) => {
        if (!Object.hasOwnProperty(datum.userName)) {
          dataObject[datum.userName] = datum;
        }
      });
      emplList = Object.values(dataObject);
      console.warn(operatorList);
      this.updateEmployeeList(emplList);
      this.updateIntegrationDetails('userList', operatorList);
      this.employees = JSON.parse(JSON.stringify(this.employeeList));
      this.operators = JSON.parse(JSON.stringify(this.integrationDetailsFromStore.userList));
      this.tempEmployees = this.employees;
      this.tempOperators = this.operators;
      // this.operators = [];
      // this.operators = this.integrationDetailsFromStore.userList;
    } else {
      this.$store.commit('enqueueMessage', {
        infoType: 'failed',
        infoMsg: this.$t('psaIntegration.noOpertatorSelected')
        .toString(),
      },
      );
      // this.renderErrorMessage('No operators selected.');
    }
  }

  onSerachEmployee(value: string) {
    // console.warn(this.employees.map((emp:any) => emp.userName.includes(value)));
    if (value === '') {
      this.employees = this.tempEmployees;
    } else {
      if (value !== '' && this.employees.some((emp:any) => emp.userName.includes(value) || emp.fullName.includes(value))) {
        this.employees = this.employees.filter((emp:any) => emp.userName.includes(value) || emp.fullName.includes(value));
      } else {
        this.employees = this.tempEmployees;
      }
    }
  }

  convertStringToArrayOfObjects(list: any) {
    let data = list.replace(/[[\]]/g, '');
    data = data.split(', {');
    const tempData: any[] = [];
    data.forEach((item: any, index: number) => {
      let currItem = item.replace(/'/g, '"');
      if (index > 0) {
        currItem = `{${currItem}`;
      }
      tempData.push(JSON.parse(currItem));
    });
    // console.warn(tempData);
    return tempData;
  }

  onSerachOperator(value: string) {
    if (value === '') {
      this.operators = this.tempOperators;
    } else {
      if (value !== '' && this.operators.some((opr:any) => opr.userName.includes(value) || opr.fullName.includes(value))) {
        this.operators = this.operators.filter((opr:any) => opr.userName.includes(value) || opr.fullName.includes(value));
      } else {
        this.operators = this.tempOperators;
      }
    }
  }

  created() {
    // this.fetchServerDetails();
    this.isStep1Validated;
    this.usersList();
    // if (this.environment === 'DEV') {
    //   this.steps.push({ label: '3', title: 'Operators', state: 'default' },
    //                   { label: '4', title: 'Review', state: 'default' });
    //   this.wizardBodyTitle.splice(2, 0, '');
    //   this.count = this.steps.length;
    // } else if (this.environment !== 'DEV') {
    //   this.steps.push({ label: '3', title: 'Review', state: 'default' });
    //   this.count = this.steps.length;
    // }
  }

  // For toaster message
  showToastMessage(infoMsg: string, infoType: string): void {
    // success and failed
    const message: InfoState = { infoType, infoMsg };
    this.$store.commit('displayMessage', message);
  }
}
